import React from 'react';
import Cards from '../Cards';
import Footer from'../Footer';

function Blogs() {
    return (
        <div>
            <Cards />
            <Footer />
        </div>
    )
}

export default Blogs
